import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { removeToken } from "./utilFunctions";
import BusinessIcon from "@mui/icons-material/Business";
import { USER_ROLES } from "./constants";
import DashboardIcon from "@mui/icons-material/Dashboard";
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import FolderIcon from '@mui/icons-material/Folder';
import GroupIcon from '@mui/icons-material/Group';

export const getMainMenuItems = (t, user) => {
    const role = user?.role;

    const allItems = [
        {
            icon: <DashboardIcon />,
            label: t("dashboard"),
            link: "/",
            roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.EMPLOYEE],
        },
        {
            icon: <GroupIcon />,
            label: t("activity"),
            roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.EMPLOYEE],
            children: [
                { label: t("team"), link: "/team" },
                { label: t("team_activity"), link: "/teamactivity" },
            ],
        },
        {
            icon: <WorkspacesIcon />,
            label: t("project_settings"),
            roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN],
            link: "/projectSettings",
        },
        {
            icon: <FolderIcon />,
            label: t("projects_menuItem"),
            link: "/projects",
            roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
        },
        // {
        //     icon: <WorkspacesIcon />,
        //     label: t("project_settings"),
        //     roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
        //     children: [
        //         { label: t("team"), link: "/about/team" },
        //         { label: t("vision"), link: "/about/vision" },
        //     ],
        // },
    ];

    return allItems.filter(item => item.roles.includes(role));
};

export const getBottomMenuItems = (t, navigate, user) => {
    const role = user?.role;

    const allBottomItems = [
        {
            icon: <SettingsIcon />,
            label: t("settings"),
            link: "/settings",
            roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.EMPLOYEE],
        },
        {
            icon: <BusinessIcon />,
            label: t("companySettingsMenuItem"),
            link: "/companySettings",
            roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN],
        },
        {
            icon: <LogoutIcon />,
            label: t("logout"),
            action: () => {
                console.log("Logging out...");
                setTimeout(() => {
                    removeToken();
                    navigate("/login");
                }, 0);
            },
            roles: [USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.EMPLOYEE],
        },
    ];

    return allBottomItems.filter(item => item.roles.includes(role));
};